import { render } from "./MySkills.vue?vue&type=template&id=4c046405&scoped=true"
import script from "./MySkills.vue?vue&type=script&lang=js"
export * from "./MySkills.vue?vue&type=script&lang=js"

import "./MySkills.vue?vue&type=style&index=0&id=4c046405&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Marti\\Desktop\\Web Development\\portfolio-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c046405"]])

export default __exports__